import {
    isValidElement,
    type ReactNode
} from "react";
import type {
    ItemLayoutConstantType,
    ItemPartKind,
    ItemLayout
} from "./type";
import {
    flattenCardChildren
} from "../card/util";

export const ITEM_PART_KINDS: Array<ItemPartKind> = [
    "description",
    "separator",
    "actions",
    "content",
    "header",
    "footer",
    "media",
    "title",
    "group",
    "item"
];

const isItemPartKind = (value: unknown): value is ItemPartKind => {
    return typeof value === "string" && ITEM_PART_KINDS.some((kind) => kind === value);
};

export const getItemPartKind = (node: ReactNode): ItemPartKind | undefined => {
    if(!isValidElement(node)) {
        return undefined;
    }

    const elementType: unknown = node.type;

    if(typeof elementType !== "function" && (typeof elementType !== "object" || elementType === null)) {
        return undefined;
    }

    if(!("itemPart" in elementType)) {
        return undefined;
    }

    return isItemPartKind(elementType.itemPart) ? elementType.itemPart : undefined;
};

export const getItemLayout = ({
    children
}: ItemLayoutConstantType): ItemLayout => {
    const nodes = flattenCardChildren(children);

    return {
        footers: nodes.filter((node) => getItemPartKind(node) === "footer"),
        headers: nodes.filter((node) => getItemPartKind(node) === "header"),
        body: nodes.filter((node) => {
            const kind = getItemPartKind(node);

            return kind !== "header" && kind !== "footer";
        })
    };
};
